const toStr = Object.prototype.toString;

/**
 * Extend class with multiple constructors
 *
 * @param {any} derivedCtor
 * @param {any[]} constructors
 */
export function applyMixins(derivedCtor, constructors) {
	for (const baseCtor of constructors) {
		for (const name of Object.getOwnPropertyNames(baseCtor.prototype)) {
			Object.defineProperty(
				derivedCtor.prototype,
				name,
				Object.getOwnPropertyDescriptor(baseCtor.prototype, name) || Object.create(null),
			);
		}
	}
}

/**
 * @param {string} name
 * @param {string} defaultValue
 */
export function getCssVar(name, defaultValue = '') {
	return String(window.getComputedStyle(document.documentElement).getPropertyValue('--' + name) ?? defaultValue).trim();
}

/**
 * @param {Set} a
 * @param {Set} b
 */
export const setIntersect = (a, b) => new Set([...a].filter(x => b.has(x)));

/**
 * @param {Set} a
 * @param {Set} b
 */
export const setDiff = (a, b) => new Set([...a].filter(x => !b.has(x)));

/**
 * @param {Map} a
 * @param {Map} b
 */
export const mapIntersect = (a, b) => new Map([...a].filter(([k]) => b.has(k)));

/**
 * @param {Map} a
 * @param {Map} b
 */
export const mapDiff = (a, b) => new Map([...a].filter(([k]) => !b.has(k)));

/**
 * @param {any} obj
 * @param {string} type
 */
export const isType = (obj, type) => toStr.call(obj) === `[object ${type}]`;

/**
 * @param {any} obj
 */
export const getType = obj => toStr.call(obj).slice(8, -1);

/**
 * Shout-out to AngusCroll (https://goo.gl/pxwQGp)
 *
 * @param {any} obj
 */
export const toType = (obj) => {
	if (obj === null || obj === undefined) {
		return `${obj}`;
	}
	return Object.prototype.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
};

/**
 * @param {any} obj
 */
export const filterEmptyKeys = obj => Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));

/**
 * Kudos to sindresorhus
 * @link https://github.com/sindresorhus/is-plain-obj
 *
 * @param {any} value
 */
export function isPlainObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
export const isObject = (/** @type {{ constructor: ObjectConstructor; }} */ obj) => obj && typeof obj === 'object' && obj.constructor === Object;
export const isEmptyPlainObject = (/** @type {{ constructor: ObjectConstructor; }} */ obj) => isObject(obj) && Object.keys(obj).length === 0;

/**
 * @param {number} ms
 */
export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

/**
 * @param {number} ms
 */
export const cancelableDelay = (ms) => {
	let timer;
	const cancel = () => {
		window.clearTimeout(timer);
	};
	const promise = new Promise((resolve) => {
		timer = window.setTimeout(resolve, ms);
	});
	// @ts-ignore
	promise.cancel = cancel;
	return promise;
};